import { ResourceLoader } from './resource_loader';

import { IRegion } from'../../../dip/library/di-hnf/di-hnf.js';
import dom from'../../../pip/library/pi-dom/pi-dom.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class RegionBuilder {
  /**
   *
   */
  static build(region: IRegion): HTMLElement {
    const regionType = ['dialog', 'drawer'].includes(region.region) ? region.region : 'section';
    const regionRule = f1.strategy(dom.strategy.region, regionType);
    const regionEl = regionRule({
      'x-view': ResourceLoader.activeView(region),
      'x-region': region.region,

      // @deprecated compatibility with shell
      //
      'x-shell': 'view'
    });

    regionEl.addEventListener(
      'close-ended',
      () => {
        if (window && window.history) {
          window.history.back();
        }
      },
      { once: true }
    );

    return regionEl;
  }

  static destroy(region: IRegion, rootEl: HTMLElement) {
    const isRegionOwned = this.isRegionOwned(region);
    const regionQuery = isRegionOwned ? region.region : `[x-region="${region.region}"]`;
    const regionChildrenQuery = `:scope > ${regionQuery}`;

    const regionEl = dom.queryOne(regionChildrenQuery, rootEl);
    if (!regionEl) {
      return;
    }

    if (isRegionOwned) {
      f1.each((el) => dom.destroy(el), f1.to.array(regionEl.children));
    } else {
      dom.destroy(regionEl);
    }

    return region;
  }

  static locate(region: IRegion, rootEl: HTMLElement): Element {
    return dom.queryOne(region.region, rootEl) || dom.constants.noEl;
  }

  /**
   * an owned region is one which is owned by another region. Micro should not create it
   */
  static isRegionOwned(region: IRegion): boolean {
    const isOwnedRegionName = /^[a-z0-9-_]*$/i;
    const regionName = region.region;

    return f1.is.empty(f1.match(isOwnedRegionName, regionName));
  }
}
